import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	home: null,
	events: null,
	search: null,
	email: {
		unsubscribe: null
	},
	profile: {
		overview: null,
		matches: null,
		standings: null,
		stats: null,
		career: null,
		social: null,
		guardianship: null
	},
	myOrganizations: null,
	myKids: null,
	myGuardians: null,
	guardianship: null,
	feed: null,
	following: null,
	store: null,
	waivers: null,
	dataExports: null
});
